import { render, staticRenderFns } from "./baleMoreSku.vue?vue&type=template&id=b921a0b8&scoped=true&"
import script from "./baleMoreSku.vue?vue&type=script&lang=js&"
export * from "./baleMoreSku.vue?vue&type=script&lang=js&"
import style0 from "./baleMoreSku.vue?vue&type=style&index=0&id=b921a0b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b921a0b8",
  null
  
)

export default component.exports